import { createApp, Component, App } from 'vue'
import i18n from '@/i18n'            // ← 引入全局 i18n 实例
import router from '@/router'
const prefix = process.env.vue_APP_PREFIX

const useShowComponent = (idName: string, component: Component) => {


    let app: App<Element> | null = null

    const hide = () => {
        if (app) {
            app.unmount()
            app = null
            document.getElementById(`${prefix}-${idName}`)?.remove()
        }
    }

    const show = (options?: Record<string, any>) => {
        hide() // 清理现有实例

        const mountNode = document.createElement('div')
        mountNode.id = `${prefix}-${idName}`
        document.body.appendChild(mountNode)

        app = createApp(component, options)
        app.use(i18n)  // ← 注册 i18n 插件
        app.use(router)
        app.mount(mountNode)

        return app
    }

    return { show, hide }
}
export default useShowComponent